import actions from "./actions";
import { CHECK_TRANSACTION_ID, GENERATE_TRANSACTION_ID, RECEIVED_REPORT, UPDATE_HOME_STATE } from "./constants";

const initialState = {
  transactionId: "",
  isCompleted: false,
  isOffline: false,
};

const homeReducer = (state = initialState, action) => { 
  const { payload, type } = action;
  switch (type) {
    case CHECK_TRANSACTION_ID.success: {
      return {
        ...state,
        transactionId: payload?.data?.transactionId,
        isCompleted: payload?.data?.hasreport && payload?.data?.reportStatus !== 'None'
      }
    }
    case GENERATE_TRANSACTION_ID.success: {
      return {
        ...state,
        transactionId: payload?.data?.transactionId,
        isCompleted: false,
      }
    }
    case RECEIVED_REPORT.success: {
      return {
        ...state,
        isCompleted: true,
      }
    }
    case UPDATE_HOME_STATE.request: {
      return {
        ...state,
        [payload.key]: payload.value
      }
    }
    default:
      return state;
  }
};

export default homeReducer;
